var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"wrapper",staticStyle:{"width":"100%","height":"100%"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }